export type { MagCurve, FineRt60, BandRt60, RoomAcoustics, SynthOptions, SynthResult } from './types';
export { AuralizationEngine, type EngineCallbacks, type EngineOptions, type TrimWindow } from './engine';
export { synthesizeIR } from './irSynth';
export { convolveAll } from './convolve';
/** Where the synthesized IR hands the modal fine grid over to the band table
 *  — a caller shaping its own RT60 data splits it here. */
export { MODAL_CROSSOVER_HZ } from './dsp';

export interface SampleDef {
  id: string;
  label: string;
  url: string;
  hint: string;
  startSec?: number;
  endSec?: number;
}

/** Built-in dry samples — apps host the wav files under /audio/samples/. */
export const AURALIZATION_SAMPLES: readonly SampleDef[] = [
  { id: 'electronic', label: 'Electronic', url: '/audio/samples/song-electronic.wav', hint: 'Bass-heavy electronic track', startSec: 24, endSec: 56 },
  { id: 'jazz', label: 'Saxophone', url: '/audio/samples/song-jazz.wav', hint: 'Saxophone — decay and space', startSec: 0, endSec: 38 },
  { id: 'top-loop', label: 'Top loop', url: '/audio/samples/top-loop.wav', hint: 'Percussion / hats — early reflections' },
  { id: 'kick', label: 'Kick', url: '/audio/samples/kick.wav', hint: 'Punchy kick drum — low-mid decay / one-note boom' },
];
